import { useRef } from 'react';
import './UserFlowSectionComponent.css';
import { useScrolledInto } from '../responsive/scroll';
import orbiinIcon from '../Images/orbiin_logo_white.png';

const UserFlowSectionComponent = () => {
    const sectionRef = useRef(null);
    // Labels pop in in two waves (were showFirstWave and >= 12492)
    const showFirstWave = useScrolledInto(sectionRef, 0.635);
    const showSecondWave = useScrolledInto(sectionRef, 0.3125);
    return <div ref={sectionRef} className="viewport grid-parent user-flow-layout">
        <span className="user-flow-title title">User Flow</span>

        <div className="orbiin-logo-user-flow">
            <img id="orbiin-user-flow-img" src={orbiinIcon} alt="Orbiin Logo" />
        </div>

        { showFirstWave ? <span className="inverted location-span">Location</span> : "" }
        <div id="location-line"></div>

        { showFirstWave ? <span className="inverted overlay-span">Overlay</span> : "" }
        <div id="overlayy-line"></div>

        { showFirstWave ? <span className="inverted permissions-span">Permissions</span> : "" }
        <div id="permissions-line"></div>

        { showFirstWave ? <span className="inverted login-signup-span">Login / Sign Up</span> : "" }
        <div id="login-line"></div>

        { showFirstWave ? <span className="during-drive-span">During Drive</span> : "" }
        <div id="drive-line"></div>

        { showFirstWave ? <span className="notifications-span">Notifications</span> : "" }
        <div id="notification-line"></div>

        { showFirstWave ? <span className="alerts-span">Alerts</span> : "" }
        <div id="alert-line"></div>

        { showSecondWave ? <span className="inverted stickers-span">Stickers</span> : "" }
        { showSecondWave ? <span className="inverted discover-span">Discover</span> : "" }
        <div id="discover-line"></div>

        { showSecondWave ? <span className="inverted rewards-span">Rewards</span> : "" }
        <div id="rewards-line"></div>

        { showSecondWave ? <span className="inverted points-span">Points</span> : "" }

        { showSecondWave ? <span className="contribution-span">Contribution</span> : "" }
        <div id="contribution-line"></div>

        { showSecondWave ? <span className="end-of-drive-span">End of Drive</span> : "" }
    </div>
};

export default UserFlowSectionComponent;